<template>
    <div id="workflow-sticky-table" style="width: 100%;">
        <v-data-table :headers="headers" :items="items" hide-default-footer fixed-header>
            <template v-slot:body="props">
              <tbody>
                <tr v-for="(item, index) in items" :key="index" >
                  <td class="td_order">
                    <v-avatar :size="30" color="grey lighten-4">
                        <v-icon v-if="item.is_destination === 0" color="teal accent-3">mdi-check</v-icon>
                        <span v-else >{{ index }}</span>
                    </v-avatar>
                  </td>
                  <td class="td_name">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">{{ item.destination_user_name }}</span>
                      </template>
                      <span>{{ item.destination_user_name }}</span>
                    </v-tooltip>
                  </td>
                  <td class="td_email"> {{ item.destination_email_address }} </td>
                  <td class="td_company"> {{ item.destination_company_name }} </td>
                  <td class="td_access_code"> 
                      <v-icon v-if="item.has_access_code">mdi-lock</v-icon>
                  </td>
                  <td class="td_remarks">
                    <div class="text-right" v-if="item.is_destination === 0" >送信者<span v-if="user.email === item.destination_email_address">(あなた)</span></div>
                    <div class="text-right" v-else-if="item.is_authorizer === 1" >送付先 {{ index }} <span v-if="user.email === item.destination_email_address">(あなた)</span><span v-else>(承認者)</span></div>
                    <div class="text-right" v-else >送付先 {{ index }} <span v-if="user.email === item.destination_email_address">(あなた)</span><span v-else>(署名者)</span></div>
                  </td>
                </tr>
              </tbody>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // items: null,
                headers: [
                    { text: '', value: 'sn', sortable: false, width: '65' },
                    { text: '氏名', value: 'destination_user_name', sortable: false },
                    { text: 'メールアドレス', value: 'destination_email_address', sortable: false },
                    { text: '会社名', value: 'destination_company_name', sortable: false },
                    { text: '', value: 'has_access_code', sortable: false, width: '50'  },
                    { text: '備考', value: 'remarks', sortable: false, width: '75'  },
                ],
            };
        },
        props: {
            user: Object,
            items: Array
        },
        // 初期表示のデータ
        created : function() {
        },
        computed: {
        },
        methods: {
            confirmDialog: function(item) {
                this.currentIndex = this.signerItems.indexOf(item);
                this.currentItem = item;
                this.confirmDeleteDialog = true;
            },
            deleteItem: function(item) {
                const index = this.signerItems.indexOf(item);
                this.signerItems.splice(index, 1);
            },
        },
    };
</script>

<style scoped lang="scss">
    /* table */
    ::v-deep th {
        padding: 5px 0!important;
        word-break: keep-all;
        white-space : nowrap;
    }

    ::v-deep td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
        padding: 5px 0!important;
    }
    ::v-deep .v-data-table__empty-wrapper {
        display: none;
    }
    .td_order {
        width: 69px;
        text-align: center;
    }
    .td_name {
        width: 200px;
        max-width:400px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .td_email {
        /*width: 250px;*/
        padding-right: 15px !important;
    }
    .td_access_code {
        width: 50px;
        text-align: center;
    }
    .td_remarks {
        width: 75px;
        text-align: center;
    }
</style>

<style>
    #workflow-sticky-table > div > div > table > tbody > tr:hover > td
    {
        background:#EEE !important;
    }

    /* datatableの列を固定化する(1列目) */
    #workflow-sticky-table > div > div > table > tbody > tr > td:nth-child(1),
    #workflow-sticky-table > div > div > table > thead > tr > th:nth-child(1)
    {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 0px;
        z-index: 97;
        background:white;
    }
    #workflow-sticky-table > div > div > table > thead > tr > th:nth-child(1)
    {
        z-index: 98;
    }
     
    /* datatableの列を固定化する(2列目) */
    /* 1列目の幅の分だけ、leftの値を増やして固定化する */
    #workflow-sticky-table > div > div > table > tbody > tr > td:nth-child(2),
    #workflow-sticky-table > div > div > table > thead > tr > th:nth-child(2)
    {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 65px;
        z-index: 97;
        background:white;
    }

    #workflow-sticky-table > div > div > table > thead > tr > th:nth-child(2)
    {
        z-index: 98;
    }
</style>
